// Utils
import Yup from "../../../utils/yup";

export default Yup.object().shape({
  orderType: Yup.string().required("Required"),
});
